import { render } from "./ItemCheckEditor.vue?vue&type=template&id=226bb9bf"
import script from "./ItemCheckEditor.vue?vue&type=script&lang=ts"
export * from "./ItemCheckEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script